import React from 'react';
import { trackEvent } from '../../hooks/useMetaPixel';
interface CTAButtonProps {
  formattedPrice: string;
  loading?: boolean;
  className?: string;
  size?: 'lg' | 'xl';
}
export function CTAButton({
  formattedPrice,
  loading = false,
  className = '',
  size = 'lg'
}: CTAButtonProps) {
  const sizeClasses = {
    default: 'px-8 md:px-10 py-4 md:py-5 text-lg md:text-xl',
    xl: 'px-8 md:px-12 py-5 md:py-6 text-xl md:text-2xl'
  };
  const handleClick = () => {
    trackEvent('AddToCart', {
      content_name: 'Resin Without Errors',
      content_type: 'product',
      value: formattedPrice,
      currency: 'USD'
    });
  };
  return <a href="https://flawless-resin.shop/cart/48237768278271:1" target="_blank" rel="noopener noreferrer" onClick={handleClick} className={`
        inline-flex items-center justify-center text-center
        bg-amber text-dark font-bold font-lato rounded-lg
        transition-all duration-300 ease-out
        hover:brightness-110 hover:scale-[1.02] active:scale-[0.98]
        glow-amber hover:glow-amber-lg
        ${sizeClasses[size]}
        ${className}
      `} data-id="element-416">
      {loading ? <span className="flex items-center gap-2" data-id="element-417">
          Yes, I Want Instant Access —{' '}
          <span className="w-12 h-5 bg-dark/20 rounded animate-pulse inline-block" data-id="element-418"></span>{' '}
          »
        </span> : <span data-id="element-419">Yes, I Want Instant Access — {formattedPrice} »</span>}
    </a>;
}